<!-- <div class="container">
    <mat-progress-spinner
    class="example-margin"
    color="#00A3E5"
    mode="indeterminate">
</mat-progress-spinner>
</div> -->

<div>
    <div>
        <span>Loading.....</span>
    </div>
</div>